export default "__VITE_ASSET__BzJ5lCrC__"